<template>
    <button class="c-button c-button--default c-button--shrinked" @click="openModal">
        <font-awesome-icon class="c-button__left-icon"
                           :icon="['far', 'sticky-note']"></font-awesome-icon>
        View Instructions
    </button>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        instructions: {
            type: String,
            required: true
        }
    },
    methods: {
        openModal() {
            this.$modal.show('buyer-instructions', {
                title: this.title,
                instructions: this.instructions
            })
        }
    }
}
</script>
